import { Stack } from '@mantine/core';
import { VLazyLoadMultiSelect } from '@vision/ui/components';
import { useSelectedAccountId } from '@vision/ui/hooks';
import { ReportsDetailGraphicSchemaValues } from '@vision/ui/interfaces';
import { useLazyGetSchemaFieldsV2Query } from '@vision/ui/services';
import { translateErrorMessage } from '@vision/ui/utils';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { ReportsDetailGraphicCompareLayout } from '../ReportsDetailGraphicCompareLayout';
import { ReportsDetailGraphicBaseProps } from '../report-detail-graphic-compare.util';
import { ReportsDetailGraphicCompareSchemaValues } from './ReportsDetailGraphicCompareSchemaValues';

interface ReportsDetailGraphicCompareSchemaProps extends ReportsDetailGraphicBaseProps {}

export function ReportsDetailGraphicCompareSchema({ required }: ReportsDetailGraphicCompareSchemaProps) {
  const { t } = useTranslation();
  const accountId = useSelectedAccountId();
  const formik = useFormikContext<ReportsDetailGraphicSchemaValues>();
  const selectedSchemaCodes = formik.values.selectedCompareCriteria.selectedSchemaCodes || [];
  const selectedSchemaTagIds = formik.values.selectedCompareCriteria.selectedSchemaTagIds || [];

  const handleSchemaChange = (value: string[]) => {
    formik.setFieldValue('selectedCompareCriteria.selectedSchemaCodes', value);
    formik.setFieldValue('selectedCompareCriteria.selectedSchemaTagIds', []);
  };

  return (
    <ReportsDetailGraphicCompareLayout title={t('schema')}>
      <Stack gap={12}>
        <VLazyLoadMultiSelect
          id="report-compare-schema"
          data-testid="input-report-compare-schema"
          label={t('schema')}
          useLazyApiQueryFunction={useLazyGetSchemaFieldsV2Query}
          apiRequestParameters={{
            accountId,
          }}
          multiSelectItemMapper={(items) =>
            items.map((item) => ({
              value: item.id,
              label: item.field_name,
            }))
          }
          searchKey="search_string"
          value={selectedSchemaCodes}
          onBlur={formik.handleBlur}
          onChange={handleSchemaChange}
          error={translateErrorMessage(formik, 'selectedCompareCriteria.selectedSchemaCodes')}
          withAsterisk={required}
        />

        {selectedSchemaCodes.length > 0 && (
          <ReportsDetailGraphicCompareSchemaValues
            key={selectedSchemaCodes.join(',')}
            accountId={accountId}
            schemaFieldIds={selectedSchemaCodes}
            value={selectedSchemaTagIds}
            onChange={(value) => formik.setFieldValue('selectedCompareCriteria.selectedSchemaTagIds', value)}
            onBlur={formik.handleBlur}
            error={translateErrorMessage(formik, 'selectedCompareCriteria.selectedSchemaTagIds')}
          />
        )}
      </Stack>
    </ReportsDetailGraphicCompareLayout>
  );
}
